import { makeStyles, Theme } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { style } from 'commons/constants/KeyFlowConstants';

export const SCRIPT_HEIGHT = 90;
const RANGE_TYPE_HEIGHT = 60;
export const BORDER_COLOR = '#2a303d';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    padding: 0,
    margin: 0,
    height: '1830px',
    [theme.breakpoints.down('md')]: {
      height: '995px',
    },
    // height: '995px',
    // height: 'calc(100vh - 400px)',
    color: '#ffffff',
    letterSpacing: 0,
  },

  justifyStart: {
    justifyContent: 'start',
  },
  justifyEnd: {
    justifyContent: 'end',
  },
  justifyCenter: {
    justifyContent: 'center',
  },

  rowContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 20px',
    gap: '12px',
    width: '100%',
    height: `${SCRIPT_HEIGHT}px`,

    '&:not(:last-child)': {
      borderBottom: `1px solid ${BORDER_COLOR}`,
    },

    '&:hover': {
      backgroundColor: 'rgba(90, 90, 90, 0.4)',
      cursor: 'pointer',
    },
  },

  selected: {
    backgroundColor: 'rgba(90, 90, 90, 0.4)',
  },

  selectedHomeTeam: {
    '& > div:first-child': {
      outline: '3px solid rgba(202, 90, 150, 1.0)',
    },
    '& > div:nth-child(2)': {
      fontWeight: 'bold',
    },
  },
  selectedAwayTeam: {
    '& > div:first-child': {
      fontWeight: 'bold',
    },
    '& > div:nth-child(2)': {
      outline: '3px solid rgba(202, 90, 150, 1.0)',
    },
  },
  loadingContainer: {
    width: '60px',
    height: '60px',
    flex: '0 0 60px',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(90deg, #d3d3d3 25%, #f3f3f3 37%, #d3d3d3 63%)',
    backgroundSize: '500% 100%',
    animation: '$skeleton-loading 1.4s ease infinite',
  },
  '@keyframes skeleton-loading': {
    '0%': {
      backgroundPosition: '100% 0',
    },
    '100%': {
      backgroundPosition: '0% 0',
    },
  },
  thumbnailContainer: {
    width: '60px',
    height: '60px',
    flex: '0 0 60px',
    borderRadius: '100%',
    backgroundColor: '#fff',
    overflow: 'hidden',
    display: 'flex',
  },

  playerImageContainer: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transformOrigin: 'top center',
    transform: 'scale(1.55)',
  },

  teamThumbnailContainer: {
    width: '60px',
    height: '60px',
    flex: '0 0 60px',
    borderRadius: '100%',
    backgroundColor: '#fff',
    overflow: 'hidden',
    position: 'relative',
  },
  imageTeamContainer: {
    width: '85%',
    objectFit: 'contain',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  contentsContainer: {
    display: 'flex',
    flexDirection: 'column',
    // width: 'calc(80% - 100px)',
    width: '100%',
    // border: '1px solid tomato',
  },

  titleContainer: {
    fontSize: '14px',
  },

  timeContainer: {
    display: 'flex',
    gap: '4px',
    '& > p': {
      fontSize: '12px',
      margin: 0,
    },
    opacity: 0.65,
  },

  textAlignLeft: {
    textAlign: 'left',
  },
  textAlignRight: {
    textAlign: 'right',
  },
  textAlignCenter: {
    textAlign: 'center',
  },

  heartContainer: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      color: '#ffffff',
    },
  },
  scriptLoadingContainer: {
    padding: '20px 0 20px 0',
  },
  circularProgress: {
    color: 'rgba(255, 255, 255, 1.0)',
  },
  displayNone: {
    display: 'none',
  },
  invisible: {
    visibility: 'hidden',
  },
  scriptListLoading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-16px, -16px)',
  },

  rangeType: {
    backgroundColor: style.PINK_COLOR_DARKER,

    '&:hover': {
      backgroundColor: style.PINK_COLOR_DARKER_HOVER,
    },
    height: `${RANGE_TYPE_HEIGHT}px`,
  },

  selectedRangeType: {
    backgroundColor: style.PINK_COLOR_DARKER_HOVER,
    '& > div:first-child': {
      fontWeight: 'bold',
    },
  },
}));

export default useStyles;
